
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/healthwatch-newsletter-subscription",
      function () {
        return require("private-next-pages/healthwatch-newsletter-subscription/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/healthwatch-newsletter-subscription"])
      });
    }
  